module.exports = __webpack_public_path__ + "static/contentful-db46522cad6ec65403571a3b1d1191bf.png";